import React, { useState } from "react";
import { AppModal, AppRemixIcon } from "@/layout/AppComponents";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import ReactDOMServer from "react-dom/server";
import colors from "../../../../../../../constants/colors";
import ErrorHandler from "../../../../../../components/error/ErrorHandler";
import { axiosPath } from "../../../../../../../routing/helpers/router";
import plantObligationStates from "../../../../../../../constants/plantObligationStates";
import Translator from "../../../../../../components/helpers/Translator";

const StateHistory = (props) => {
  const { state, plantObligationID } = props;
  const dispatch = useDispatch();
  const { moduleBridgeHex, plantHex } = useParams();
  const customStates = useSelector((s) => s.auth?.customStates);
  const permissions = useSelector(
    (s) => s.module[moduleBridgeHex]?.permissions,
  );
  const poLevel3 = useSelector(
    (s) => s.currentPage?.plantObligationLevels?.level3?.[plantObligationID],
  );
  const [showHistory, setShowHistory] = useState(false);
  const [changes, setChanges] = useState(null);

  // > LOAD CHANGES
  const loadModuleList = async () => {
    try {
      const response = await axios.post(
        axiosPath(
          'api_r_user_module_legalCompliance_evaluation_getStateHistory',
        ),
        { plantObligationID, plantHex, moduleBridgeHex },
      );
      setChanges(response.data);
      setShowHistory(true);
    } catch (err) {
      dispatch(ErrorHandler(err, history));
    }
  };
  // < LOAD CHANGES

  return (
    <>
      <AppRemixIcon
        onClick={() => loadModuleList()}
        icon="calendar-check"
        title={ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="see.state.history" />,
        )}
        color={
          poLevel3?.alerts?.stateHistory ? colors.primaryLight : colors.grey300
        }
        filled={state}
        className="pointer"
      />
      <AppModal
        show={showHistory}
        onClose={() => setShowHistory(false)}
        title={ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="state.history" />,
        )}
      >
        <Scrollbars style={{ height: '380px' }}>
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">
                  <Translator file="module-legalCompliance" name="date" />
                </th>
                <th scope="col">
                  <Translator file="user" name="user.state" />
                </th>
                {permissions?.gcl?.module?.plant?.evidences?.showUserName && (
                  <th scope="col">
                    <Translator file="general" name="general.user" />
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {changes &&
                changes.map((c) => (
                  <tr key={c.id}>
                    <td scope="row">{c.dateStamp}</td>
                    <td>
                      {c.state !== 6 ? (
                        <b
                          className="p-1"
                          style={{
                            background: plantObligationStates[c.state].bgColor,
                            color: plantObligationStates[c.state].iconColor,
                            borderRadius: '2px',
                          }}
                        >
                          <Translator
                            file="user"
                            name={`user.obligations.state${
                              plantObligationStates[c.state].id
                            }`}
                          />
                        </b>
                      ) : (
                        <>
                          {customStates[c.customState] ? (
                            <b
                              className="p-1"
                              style={{
                                background: customStates[c.customState].bgColor,
                                color: customStates[c.customState].fgColor,
                                borderRadius: '2px',
                              }}
                            >
                              {customStates[c.customState].name}
                            </b>
                          ) : (
                            <span>A</span>
                          )}
                        </>
                      )}
                    </td>
                    {permissions?.gcl?.module?.plant?.evidences
                      ?.showUserName && <td>{c.user}</td>}
                  </tr>
                ))}
            </tbody>
          </table>
        </Scrollbars>
      </AppModal>
    </>
  );
};
export default StateHistory;
